import { initializePaddle } from "@paddle/paddle-js";

let paddlePromise = null;

/**
 * Lazily-initialized singleton Paddle instance for Paddle.js v2.
 * Reads REACT_APP_PADDLE_ENVIRONMENT + REACT_APP_PADDLE_CLIENT_TOKEN.
 */
export function getPaddle() {
  if (!paddlePromise) {
    const token = process.env.REACT_APP_PADDLE_CLIENT_TOKEN;
    const env = process.env.REACT_APP_PADDLE_ENVIRONMENT === "production" ? "production" : "sandbox";
    if (!token) {
      paddlePromise = Promise.resolve(null);
    } else {
      paddlePromise = initializePaddle({ environment: env, token }).catch((e) => {
        console.error("Paddle init failed", e);
        return null;
      });
    }
  }
  return paddlePromise;
}
